<template>
  <div v-loading="loading">
    <back />
    <div class="det">
      <div class="top">
        <div class="title">游学信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col>
              <el-form-item label="封面图片:">
                <el-image style="width: 80px;height: 80px; " :src="url" :preview-src-list="[url]" fit="contain">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline" style="font-size: 80px;color: #2a2a2a;"></i>
                  </div>
                </el-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="游学名称:">
                <div>{{ ruleForm.name }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="人  数:">
                <div>{{ ruleForm.peopleCount }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="销售价:">
                <div>{{ ruleForm.price }} 元</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="类目:">
                <div>{{ ruleForm.categoryName }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="带队老师:">
                <div>{{ ruleForm.teacherName }}</div>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="5">
              <el-form-item label="购买人数:">
                <div>{{ ruleForm.signUpCount || '--' }}</div>
              </el-form-item>
            </el-col> -->
            <el-col :span="11">
              <el-form-item label="游学时间:">
                <div>{{ `${ruleForm.startTime} ~ ${ruleForm.endTime}` }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5"></el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 订单信息 -->
      <div class="top">
        <div class="title">订单信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="订单编号：">
                <div>{{ ruleForm.orderNum }}</div>
              </el-form-item>
              <el-form-item label="下单时间：">
                <div>{{ ruleForm.orderTime }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单状态：">
                <div v-if="ruleForm.orderStatus == -1">已取消</div>
                <div v-if="ruleForm.orderStatus == 0">待支付</div>
                <div v-if="ruleForm.orderStatus == 1">待出行</div>
                <div v-if="ruleForm.orderStatus == 2">已完成</div>
                <div v-if="ruleForm.orderStatus == 3">已退款</div>
              </el-form-item>
              <el-form-item label="支付时间：" v-if="ruleForm.orderStatus !== -1">
                <div>{{ ruleForm.payTime }}</div>
              </el-form-item>
              <el-form-item label="取消时间：" v-if="ruleForm.orderStatus == -1">
                <div>{{ ruleForm.cancelTime || '--' }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="订单金额:">
                <div>{{ ruleForm.orderAmount }} 元</div>
              </el-form-item>
              <el-form-item label="退款时间:" v-if="ruleForm.orderStatus == 3">
                <div>{{ ruleForm.cancelTime || '--' }}</div>
              </el-form-item>
              <!-- <el-form-item label="完成时间:" v-if="ruleForm.orderStatus == 2">
                <div>{{ ruleForm.completionTime }}</div>
              </el-form-item> -->
            </el-col>
            <el-col :span="5">
              <el-form-item label="购买人数：">
                <!-- 后端要求写固定数字 -->
                <div>1</div>
                <!-- <div>{{ ruleForm.signUpCount || '--' }}</div> -->
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 用户信息 -->
      <div class="top">
        <div class="title">用户信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="用户编号：">
                <div>{{ ruleForm.userCode }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="用户昵称：">
                <div>{{ ruleForm.nickName }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5"></el-col>
            <el-col :span="5"></el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 报名信息 -->
      <div class="top">
        <div class="title">报名信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row type="flex" justify="space-between">
            <el-col :span="5">
              <el-form-item label="姓名：">
                <div>{{ ruleForm.enrollName }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="电话号码：">
                <div>{{ ruleForm.phone }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="身份证号码：">
                <div>{{ ruleForm.idCard || '--' }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      ruleForm: {},//订单信息
      url: '',//封面图
    };
  },
  created() {
    this.getRequest()
  },
  methods: {
    getRequest() {
      this.loading = true;
      const studyTourOrderListDet = `${this.$api.studyTourOrderListDet}/${this.$route.query.id}`
      this.$axios.get(studyTourOrderListDet).then((res) => {
        const { code, result } = res
        this.loading = false;
        if (code == 100) {
          this.ruleForm = result//订单信息
          this.url = result.pictureList[0]//封面图
        }
      }).catch((err) => {
        this.$message.error(err.desc)
        this.loading = false;
      })
    },
  }
}
</script>

<style scoped lang='scss'>
.det {
  padding: 10px 0 0 10px;

  .title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #1A1A1A;
    text-align: left;
    margin-bottom: 20px;
  }

  .top {
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 30px;
    padding-bottom: 20px;

    .el-form-item {
      margin-bottom: 0px;
    }



  }

  .bottom {
    display: flex;
    align-items: flex-end;
    color: #505554;
    font-weight: bold;
    justify-content: flex-end;
    padding: 10px 0;

    div {
      margin-right: 20px;
    }
  }

}
</style>